import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('FormInputDatefield', {
    validatorFunction(input) {
        return !isNaN((new Date(d)).getTime());
    }
})

export default options